module.exports = __webpack_public_path__ + "static/media/Promart.81c44bf7.svg";